import find from 'lodash/find';
import cloneDeep from 'lodash/cloneDeep';
import groupBy from 'lodash/groupBy';
import { put, fork, take, select } from 'redux-saga/effects';
import * as actions from './actions';
import statusFlow from './statusFlow/saga';


const PRIMITIVE_ITEM_TYPE = 1;
const SIMPLE_ITEM_TYPE = 2;
const CONTAINER_ITEM_TYPE = 3;

function* setItem() {
  while (true) {
    const { id } = yield take(actions.SET_ITEM.BEGIN);
    const { itemOptions, containerOptions } = yield select(state => state.configuration.project.editor.itemType);

    let item = cloneDeep(find(itemOptions, x => x.value.id === id));
    item = item ? item : itemOptions[itemOptions.length -1];
    const { value } = item;
    const containerFor = value.containerFor && value.containerFor.map(itemId => find(containerOptions, x => x.id === itemId));
    const selectedItem = {
      ...item,
      value,
      curentOptions: containerOptions,
      containerFor,
      type: value.type,
      name: value.name,
      id: value.id,
      itemColor: value.itemColor,
      hasContainer: value.containerType !== PRIMITIVE_ITEM_TYPE,
    };
    yield put(actions.setItem.end({ selectedItem }));
    yield put(actions.statusFlow.init.begin({ statuses: value.statuses }));
  }
}

function* setContainerType() {
  while (true) {
    yield take(actions.SET_CONTAINER_TYPE.BEGIN);
    yield put(actions.setContainerType.end({ curentOptions: [] }));
  }
}

function* selectItemType() {
  while (true) {
    const { id, itemType } = yield take(actions.SELECT_ITEMTYPE.BEGIN);
    const { itemTypes, containerOptions  } = yield select(state => state.configuration.project.editor.itemType);
    const sourceItem = find(itemTypes, y => y.itemType === itemType);

     const containerFor = sourceItem.containerItemTypes && sourceItem.containerItemTypes.map(itemId => find(containerOptions, x => x.id === itemId));
    const item = {
      curentOptions: containerOptions,
      containerFor,
      type: itemType,
      containerType: sourceItem.containerType,
      hasContainer: sourceItem.containerType !== PRIMITIVE_ITEM_TYPE,
    };
    yield put(actions.selectItemType.end({item}));
  }
}

function* checkValidation() {
  while (true) {
    yield take(actions.CHECK_VALIDATION.BEGIN);
    const { currentItem: selectedItem, saving } = yield select(state => state.configuration.project.editor.itemType);

    const statusesByStatusId = groupBy(selectedItem.value.statuses, 'statusId');
    const statusErrors = Object.keys(statusesByStatusId)
      .map(statusId => ({ statusId: Number(statusId), statuses: statusesByStatusId[statusId] }))
      .filter(x => x.statusId > 0 && x.statuses.length > 1);

    let errors;
    if (statusErrors.length > 0) {
      errors = {
        statusMap: statusErrors.reduce((pre, val) => {
          val.statuses.reduce((pre2, val2) => {
            pre2[val2.$$localId] = true;
            return pre2;
          }, pre);
          return pre;
        }, {}),
      };
    }
    if (saving) {
      const emptyStatuses = selectedItem.value.statuses.filter(x => x.statusId === 0);
      if (emptyStatuses.length > 0) {
        if (!errors) {
          errors = {
            statusMap: {},
          };
        }
        emptyStatuses.reduce((pre, val) => {
          pre[val.$$localId] = true;
          return pre;
        }, errors.statusMap);
      }
    }
    yield put(actions.checkValidation.end({ errors }));
  }
}

function* resetChanges() {
  while (true) {
    yield take(actions.RESET_CHANGES.BEGIN);
    const {
      itemsModel,
      currentItem: selectedItem,
       } = yield select(state => state.configuration.project.editor.itemType);
    const itemValue = find(itemsModel, y => y.id === selectedItem.value.id);
    const value = cloneDeep(itemValue);

    const { containerOptions } = yield select(state => state.configuration.project.editor.itemType);
    const containerFor = value.containerFor && value.containerFor.map(itemId => find(containerOptions, x => x.id === itemId));
    const item = {
      value,
      curentOptions: containerOptions,
      containerFor,
      type: value.type,
      name: value.name,
      itemColor: value.itemColor,
      hasContainer: value.containerType !== PRIMITIVE_ITEM_TYPE,
    };
    yield put(actions.statusFlow.init.begin({ statuses: value.statuses }));
    yield put(actions.resetChanges.end({ item }));
  }
}

export default function* currentItem() {
  yield fork(selectItemType);
  yield fork(statusFlow);
  yield fork(setItem);
  yield fork(setContainerType);
  yield fork(checkValidation);
  yield fork(resetChanges);
}



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/itemType/currentItem/saga.js